import { combineReducers } from 'redux';
import products from '../cart/reducer';
import ui from '../ui/reducer';

export default combineReducers({
    products,
    ui
});
